import classNames from 'classnames/bind';
import styles from './FaqFeedback.module.scss';
import { FormButton, SpinnerIcon } from '@/components';
import { useState } from 'react';
let cx = classNames.bind(styles);

export function FaqFeedback({ id }) {
	const [feedbackStatus, setFeedbackStatus] = useState('unsubmitted');

	async function submitFeedback(wasHelpful) {
		setFeedbackStatus('submitting');
		const response = await fetch(`https://www.netspend.com/webapi/v2/faq/questions/${id}/feedback`, {
			method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
			body: JSON.stringify({ helpful: wasHelpful }),
		});
		if (!response.ok) {
			console.error(`Could not submit feedback: status ${response.status}, type ${response.type}`);
			setFeedbackStatus('error');
		} else {
			setFeedbackStatus('submitted');
		}
	}

	return (
		<>
			{feedbackStatus === 'unsubmitted' && (
				<div className={cx(['question-btns'])}>
					<FormButton onClick={() => submitFeedback(true)} className={cx(['feedback-btn'])}>
						Yes
					</FormButton>
					<FormButton onClick={() => submitFeedback(false)} className={cx(['feedback-btn'])}>
						No
					</FormButton>
				</div>
			)}
			{feedbackStatus === 'submitting' && (
				<SpinnerIcon className={cx(['loading-feedback-icon'])} />
			)}
			{feedbackStatus === 'error' && <p className={cx(['is-font-size-sm'])}>There was an error submitting your feedback.</p>}
			{feedbackStatus === 'submitted' && <p className={cx(['is-font-size-sm'])}>Thanks for the feedback!</p>}
		</>
	);
}
